export function setScrolled(func) {

	func();
	window.addEventListener('scroll', func);

}

export function setResized(func) {

	func();
	window.addEventListener('resize', func);

}
